import IMask from "imask";
import "../focusOnError.js";

require('dropzone');
Dropzone.autoDiscover = false;

const form = document.getElementById('listForm');
let uploadedDocumentMap = {};

let drop = new Dropzone('#file', {
    url: media_endpoint,
    maxFilesize: 5, // MB
    addRemoveLinks: true,
    acceptedFiles: ".jpeg,.jpg,.png",
    headers: {
        'X-CSRF-TOKEN': c_token,
    },
    success: function (file, response) {
        let fileData = {
            name: response.name,
            size: file.size,
        }

        let input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", "images[]");
        input.setAttribute("data-img", response.name);
        input.setAttribute("value", JSON.stringify(fileData));
        form.appendChild(input);

        uploadedDocumentMap[file.name] = response.name;
    },
    removedfile: function (file) {

        file.previewElement.remove();
        let name;
        if (typeof file.file_name !== 'undefined') {
            name = file.file_name;
        } else {
            name = uploadedDocumentMap[file.name];
        }

        // A rejected/failed upload never ran success(), so there's no input to
        // remove — without this, the resubmit keeps a photo the owner deleted.
        let input = form.querySelector('[data-img="' + name + '"]');
        if (input) {
            input.remove();
        }
    },
    init: displayOldImages,
});

function displayOldImages() {

    if (images)
        for (let i in images) {
            let image = JSON.parse(images[i]);

            let input = document.createElement("input");
            input.setAttribute("type", "hidden");
            input.setAttribute("name", "images[]");
            input.setAttribute("data-img", image.name);
            input.setAttribute("value", images[i]);
            form.appendChild(input);
            uploadedDocumentMap[image.name] = image.name;

            this.options.addedfile.call(this, image);
            this.options.thumbnail.call(this, image, '/storage/tmp/uploads/' + image.name);
            image.previewElement.classList.add('dz-success');
            image.previewElement.classList.add('dz-complete');
            image.previewElement.querySelector('[data-dz-thumbnail]')
                .classList.add('w-100', 'h-100', 'object-fit');
        }
};

// Owners used to click Submit again when nothing visibly happened, filing a
// duplicate lead. Listen on 'submit' not 'click' so native validation runs
// first and an invalid form can't dead-end the button.
const submitButton = document.getElementById('submit-all');

if (submitButton) {
    form.addEventListener('submit', (event) => {
        // The staged uploads are the ONLY source of images[] inputs, so
        // submitting mid-upload silently drops whatever hasn't finished —
        // the same "lead with no photos" outcome by a different route.
        if (drop.getUploadingFiles().length || drop.getQueuedFiles().length) {
            event.preventDefault();
            alert('Your photos are still uploading. Please wait for them to finish, then submit.');
            return;
        }

        submitButton.disabled = true;
        submitButton.textContent = 'Submitting…';
        // The form is serialized now; anything dropped after this would stage
        // a file that no images[] input references.
        drop.disable();
    });

    window.addEventListener('pageshow', (event) => {
        // A restored page still holds the previous submit's images[] inputs
        // while their staged files are gone, and drop.disable() has no undo.
        // Reloading is the only repair that covers all of it — fresh token,
        // live dropzone, clean inputs, enabled button. A reload arrives with
        // persisted === false, so this can't loop.
        if (event.persisted) {
            window.location.reload();
        }
    });
}

// Phone Number Mask
let phoneInputs = document.getElementsByClassName("phone-mask");

if (phoneInputs.length) {
    for (let input of phoneInputs) {
        let maskOptions = {
            mask: "(000) 000-0000"
        };
        IMask(input, maskOptions);
    }
}

/**
* focus on first error mesage
*/

let error = document.querySelector('.is-invalid');

if (error)
    error.focus();

if (!error) {
    let captcaErrorEl = document.querySelector('.il-captcha-error');
    if (captcaErrorEl)
        captcaErrorEl.scrollIntoView();
}

